import React, { useState } from 'react';

const CompetencyAssessment = () => {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!loginId || !password) {
      alert('Please enter both Login ID and Password.');
      return;
    }

    const targetUrl = `http://www.compasnow.com/validateTestLoad.action?id=${encodeURIComponent(loginId)}&password=${encodeURIComponent(password)}`;
    window.location.href = targetUrl; 
  };

  const handleCancel = () => {
    setLoginId('');
    setPassword('');
  };

  return (
    <div className="min-h-[85vh] bg-gradient-to-br from-blue-50 via-white to-indigo-50 py-12 px-4 sm:px-6 lg:px-8 flex items-center justify-center font-sans mt-10 mb-10">
      <div className="max-w-5xl w-full bg-white rounded-3xl shadow-[0_20px_50px_rgba(8,_112,_184,_0.07)] border border-gray-100 overflow-hidden flex flex-col md:flex-row transform transition-all">
        
        {/* Left Side: Information Panel */}
        <div className="md:w-1/2 p-10 lg:p-14 bg-gradient-to-br from-blue-700 via-blue-800 to-indigo-900 text-white relative overflow-hidden flex flex-col justify-center">
          {/* Decorative background objects */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-30 pointer-events-none">
            <div className="absolute top-[-10%] left-[-10%] w-64 h-64 rounded-full bg-blue-400 mix-blend-multiply filter blur-3xl"></div>
            <div className="absolute bottom-[-10%] right-[-10%] w-64 h-64 rounded-full bg-indigo-400 mix-blend-multiply filter blur-3xl"></div>
          </div>

          <div className="relative z-10">
            <h2 className="text-3xl lg:text-4xl font-extrabold mb-8 leading-tight tracking-tight">
              Discover Your True <br />
              <span className="text-blue-300">Potential.</span>
            </h2>
            
            <div className="space-y-6 text-blue-100/90 text-sm lg:text-[15px] leading-relaxed">
              <p>
                Due to a lack of awareness of personal strengths and incomplete information about the core competencies required for different job profiles, thousands of students land in wrong jobs where they cannot perform well.
              </p>
              <p>
                In this regard, we present the best <span className="text-white font-medium">Competency Mapping and Career Direction Tool</span>. It helps you avoid wrong choices and guides you to make appropriate career decisions based on your capabilities and corporate needs.
              </p>
              <p>
                This innovative step will help you assess areas for improvement, find required competencies, and match your strengths to the right job to achieve excellence.
              </p>
            </div>
          </div>
        </div>

        {/* Right Side: Action Panel */}
        <div className="md:w-1/2 p-10 lg:p-14 flex flex-col justify-center bg-white">
          <div className="max-w-sm w-full mx-auto">
            <div className="mb-10 text-center">
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Take the Test Now</h3>
              <p className="text-sm text-gray-500">Enter your credentials to begin</p>
            </div>
            
            <form onSubmit={handleSubmit} className="space-y-5">
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2 ml-1" htmlFor="loginId">
                  Login ID
                </label>
                <div className="relative">
                  <input
                    id="loginId"
                    type="text"
                    value={loginId}
                    onChange={(e) => setLoginId(e.target.value)}
                    className="w-full px-4 py-3.5 rounded-xl border border-gray-200 bg-gray-50 text-gray-800 focus:bg-white focus:border-blue-500 focus:ring-[3px] focus:ring-blue-100 transition-all duration-200 outline-none pl-11 shadow-sm"
                    placeholder="e.g. Sam25012700002"
                    required
                  />
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2 ml-1" htmlFor="password">
                  Password
                </label>
                <div className="relative">
                  <input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-4 py-3.5 rounded-xl border border-gray-200 bg-gray-50 text-gray-800 focus:bg-white focus:border-blue-500 focus:ring-[3px] focus:ring-blue-100 transition-all duration-200 outline-none pl-11 shadow-sm"
                    placeholder="••••••••"
                    required
                  />
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="pt-5 flex flex-col space-y-3">
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold py-3.5 px-4 rounded-xl shadow-md hover:shadow-xl hover:-translate-y-0.5 hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 flex justify-center items-center gap-2 group"
                >
                  <span>Start Assessment</span>
                  <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" /></svg>
                </button>
                
                <button
                  type="button"
                  onClick={handleCancel}
                  className="w-full bg-white border-2 border-gray-100 text-gray-500 font-semibold py-3 px-4 rounded-xl hover:bg-gray-50 hover:text-gray-700 hover:border-gray-200 transition-all duration-200"
                >
                  Clear Form
                </button>
              </div>
            </form>
            
            <div className="mt-8 pt-6 border-t border-gray-100">
              <p className="text-xs text-center text-gray-400">
                Facing issues? Contact support for assistance with your login details.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CompetencyAssessment;
